import { ReferenceFields } from 'honeygrid-types'
import { useMemo } from 'react'

import { useTargetedAreaWebsocket } from './useTargetedAreaWebsocket'

export const useHouseholdCountFromCells = (cells: string[]) => {
	const { data } = useTargetedAreaWebsocket()
	const cellMap = data?.aggregatedDemographics.cells
	const householdCount = useMemo(() => {
		if (!cells.length || !cellMap) return 0
		const households = cells.reduce((acc, cell) => {
			const cellData = cellMap[cell]
			if (cellData && cellData[ReferenceFields.Households]) {
				acc += cellData[ReferenceFields.Households]
			}
			return acc
		}, 0)
		return Math.round(households)
	}, [cellMap, cells])
	return householdCount
}
